import PropTypes from "prop-types";
import React from "react";

const CollapsibleParaContent = (props) => {
  const { text, title } = props;

  return (
    <div className="CollapsibleParaContent mb-3 pb-3 pb-lg-4">
      <h2 className="fs-18 tw:font-bold">{title}</h2>
      <p className="fs-14 m-0">{text}</p>
    </div>
  );
};

CollapsibleParaContent.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CollapsibleParaContent;
